enum ConsentsStatuses {
  draft = 'draft',
  published = 'published',
  archived = 'archived'
}

export default ConsentsStatuses;
